export enum NotificationStatus {
    Pending = 1,
    Unread = 2,
    Read = 3
}

export enum NotificationType {
    DocumentUploaded = 1,
    NoteAdded = 2,
    CourtDateAdded = 3,
    PrescriptionDate = 4,
    CaseClosed = 5
}
